import '../../scss/app.scss';
import '@popperjs/core';
import 'bootstrap/dist/js/bootstrap.bundle.min';

// 要上新的 css 就放在這邊就好了
import React, { Suspense } from 'react';
import { render } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';

// redux store
import store from '../store';

// 特效層
const EffectContainer = React.lazy(() => import('../containers/Common/EffectContainer'));

// component
const CombineHeaderContainer = React.lazy(() => import('../containers/Layouts/CombineHeaderContainer'));
// //REMIND : 新舊混合頁的參數從jsp傳入判斷Header需出現的區塊
// const pageType = window.pageType

// 測試首頁
render(
  <Provider store={store}>
    <BrowserRouter>
        <Suspense fallback={<div />}>
            <CombineHeaderContainer />
            {/* <EffectContainer /> */}
        </Suspense>
    </BrowserRouter>
  </Provider>,
  document.getElementById('combineHeaderEntry'),
);
